import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/app/(front)/(pages)/blog/[slug]/ReadingTime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/app/(front)/(pages)/blog/[slug]/ShareLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/app/(front)/(pages)/blog/[slug]/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/apps/web/src/app/(front)/(pages)/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/apps/web/src/app/(front)/(pages)/blog/[slug]/blog-styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@15.1.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/packages/i18n/src/Trans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/packages/ui/src/components/ui/translated-input.tsx");
